export class TestQuestion {

    public relations = [ 'test' ];

    public names = {
        test_id: (data) => data.test.title,
    };
}
